// paladin.core.people
const {
  name,
  version
} = require('../package.json')
import {
  ChiRhos,
  ChiRhosNext,
  PaladinCoreUtils
} from '@paladin/core'
import {
  PersonApi,
  ApiEntityRequest
} from '@chirhos/chirhos-api'

const install = (Vue, options) => {
  // Vuex dependency check (optional)
  // if (!Vue._installedPlugins.find((plugin) => plugin.Store)) {
  //   throw new Error(
  //     'PaladinCorePeople plugin must be installed after the Vuex plugin.'
  //   )
  // }

  if (PaladinCorePeople.installed) {
    return
  }
  PaladinCorePeople.installed = true

  let _timestamp = null
  if (process.env.NODE_ENV === 'development') {
    _timestamp = new Date()
    console.log(
      `%c${name}` + `%c#${version}: ` + '%cInstalling Module...',
      'color: #2ecc71',
      'color: #3498db',
      ''
    )
  }

  const {
    store /*, router */
  } = options

  if (!store) {
    throw new Error('Please provide a vuex store.')
  }

  // initialize global moduleRoutes if it doesn't exist
  Vue.$moduleRoutes = Vue.$moduleRoutes ? Vue.$moduleRoutes : []

  var routes = [{
    path: 'people',
    name: 'people',
    component: () =>
      PaladinCoreUtils.lazyLoadView(import('./router/views/people')),
    props: ( /*route*/ ) => ({
      identity: store.state.auth.identity || {},
      user: store.state.user || {},
    }),
    redirect: ( /*to*/ ) => {
      return 'people/owned'
    },
    meta: {
      authRequired: true,
      menuSettings: {
        visible: true,
        order: 3,
        pluginArea: 'navigation.main', // navigation (navigation.notifications | navigation.events) | global-menu | user-menu | footer-menu
        showChildren: false,
        icon: 'users',
        text: 'People',
        target: '/people', // can be URL or route
      },
    },
    children: [{
        path: 'all',
        name: 'people-all',
        component: () =>
          PaladinCoreUtils.lazyLoadView(import('./router/views/people/all')),
        props: ( /*route*/ ) => ({
          identity: store.state.auth.identity || {},
          user: store.state.user || {},
        }),
        meta: {
          title: 'People',
          authorize: [
            // PaladinCoreUtils.Role.ChiRhosOwner,
            // PaladinCoreUtils.Role.TenantOwner,
          ],
        },
      },
      {
        path: 'deactivated',
        name: 'people-deactivated',
        component: () =>
          PaladinCoreUtils.lazyLoadView(import('./router/views/people/deactivated')),
        props: ( /*route*/ ) => ({
          identity: store.state.auth.identity || {},
          user: store.state.user || {},
        }),
        meta: {
          title: 'People',
          authorize: [
            PaladinCoreUtils.Role.ChiRhosOwner,
            PaladinCoreUtils.Role.TenantOwner,
            PaladinCoreUtils.Role.TenantAdmin,
          ],
        },
      },
      {
        path: 'owned',
        name: 'people-owned',
        component: () =>
          PaladinCoreUtils.lazyLoadView(
            import('./router/views/people/owned')
          ),
        props: ( /*route*/ ) => ({
          identity: store.state.auth.identity || {},
          user: store.state.user || {},
        }),
        meta: {
          title: 'People managed by me',
        },
      },
      {
        path: 'relationships',
        name: 'people-relationships',
        component: () =>
          PaladinCoreUtils.lazyLoadView(
            import('./router/views/people/relationships')
          ),
        props: ( /*route*/ ) => ({
          identity: store.state.auth.identity || {},
          user: store.state.user || {},
        }),
        meta: {
          title: 'Relationships',
        },
      },
      {
        path: 'owner-requests',
        name: 'people-owner-requests',
        component: () =>
          PaladinCoreUtils.lazyLoadView(
            import('./router/views/people/owner-requests')
          ),
        props: ( /*route*/ ) => ({
          identity: store.state.auth.identity || {},
          user: store.state.user || {},
        }),
        meta: {
          title: 'Owner Requests',
        },
      },
      {
        path: 'favorites',
        name: 'people-favorites',
        component: () =>
          PaladinCoreUtils.lazyLoadView(
            import('./router/views/people/favorites')
          ),
        props: ( /*route*/ ) => ({
          identity: store.state.auth.identity || {},
          user: store.state.user || {},
        }),
        meta: {
          title: 'Favorites',
        },
      },
      {
        path: 'add',
        name: 'people-add',
        component: () =>
          PaladinCoreUtils.lazyLoadView(
            import('./router/views/people/person')
          ),
        meta: {
          title: 'Add Person',
          beforeResolve(routeTo, routeFrom, next) {
            var ChiRhosNextApi = new ChiRhosNext().api()

            ChiRhosNextApi.TenantApi.get().then(
              response => {
                if (response.data && response.data.entity) {
                  routeTo.params.presets = response.data.entity.personPropertyPresets
                  next()
                }
              },
              error => {
                console.error(error);
              }
            )
          },
        },
        props: (route) => ({
          identity: store.state.auth.identity || {},
          user: store.state.user || {},
          presets: route.params.presets || null,
        }),
      },
      {
        path: ':id',
        name: 'person',
        component: () =>
          PaladinCoreUtils.lazyLoadView(
            import('./router/views/people/person')
          ),
        meta: {
          title: 'Edit Person',
          beforeResolve(routeTo, routeFrom, next) {
            let ChiRhosApi = new ChiRhos().api()
            var personApi = new PersonApi(ChiRhosApi)
            personApi
              .Get({
                request: new ApiEntityRequest(routeTo.params.id),
              })
              .then(
                function (response) {
                  if (
                    response &&
                    response.isOk &&
                    response.data &&
                    response.data.entity
                  ) {
                    routeTo.params.person = response.data
                    routeTo.params.edit = response.security.write
                    routeTo.params.remove = response.security.delete

                    var ChiRhosNextApi = new ChiRhosNext().api()

                    ChiRhosNextApi.TenantApi.get().then(
                      response => {
                        if (response.data && response.data.entity) {
                          routeTo.params.presets = response.data.entity.personPropertyPresets
                          next()
                        }
                      },
                      error => {
                        console.error(error);
                      }
                    )
                  }
                },
                function (error) {
                  console.error(error)
                  next({
                    name: '404',
                    params: {
                      resource: 'Person'
                    },
                  })
                }
              )
          },
        },
        props: (route) => ({
          identity: store.state.auth || {},
          person: route.params.person || {},
          presets: route.params.presets || null,
          edit: route.params.edit || false,
          remove: route.params.remove || false,
        }),
      },
    ],
  }, ]

  Vue.$moduleRoutes.push(...routes)

  // export module vuex stores (optional)
  // define components (optional)
  // define global methods (optional)
  // define instance methods (optional)
  // define mixins, directives, filters, etc. (optional)

  // creates a instance method that can be used inside of a Vue component
  // Vue.prototype.$parseContent = function(content) {
  //   return helpers.parseContent(content, shortcodes)

  if (process.env.NODE_ENV === 'development') {
    let _executionTime = new Date() - _timestamp
    // console.log(`${name}#${version}: Installed in ${_executionTime}ms`)
    let _msColor = _executionTime < 100 ? '#2ecc71' : '#f1c40f'
    if (_executionTime >= 200) _msColor = '#e74c3c'
    console.log(
      `%c${name}` +
      `%c#${version}: ` +
      '%cInstalled in ' +
      `%c${_executionTime}ms`,
      'color: #2ecc71',
      'color: #3498db',
      '',
      `color: ${_msColor}`
    )
  }
}

const PaladinCorePeople = {
  install,
  version,
}

export {
  PaladinCorePeople
}

// #Automatic Installation
// For people who use your plugin outside of a module system,
// it is often expected that if your plugin is included after
// the Vue script tag, that it will automatically install itself
// without the need to call Vue.use(). You can implement this by
// appending these lines to the end of my-vue-plugin.js:
// if (typeof window !== 'undefined' && window.Vue) {
//   window.Vue.use(PaladinCoreBrowse)
// }
